import { render, staticRenderFns } from "./OwnGoodsList.vue?vue&type=template&id=23245a13&scoped=true"
import script from "./OwnGoodsList.vue?vue&type=script&lang=js"
export * from "./OwnGoodsList.vue?vue&type=script&lang=js"
import style0 from "./OwnGoodsList.vue?vue&type=style&index=0&id=23245a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23245a13",
  null
  
)

export default component.exports